import Dashboard from "views/Dashboard/Dashboard";
import Jobs from "views/Dashboard/Jobs";
import AuditCadastroView from "views/Dashboard/Fichas";
import CampanhasView from "views/Dashboard/Campanhas";
import PerguntasView from "views/Dashboard/Perguntas";
import RepositoriesViewNew from "views/Dashboard/Repositories";
import ResultsView from "views/Dashboard/Results";
import OperationsView from 'views/Dashboard/Operacoes'
import Relatorios from 'views/Dashboard/Relatorios/index'
import UsuariosView from 'views/Dashboard/Usuarios/index'
import ExtracoesView from 'views/Dashboard/Extracoes/index'
import CompaniaView from 'views/Dashboard/Companias/index'
import AudiosView from 'views/Dashboard/Audios/index';
import SingleAudio from 'views/Dashboard/Audios/AudioPage';
import LogsView from "views/Dashboard/Logs";
import ResultFichaView from "views/Dashboard/NewResults";
import TranscriptsView from "views/Dashboard/Transcripts";
import FilaView from "views/Dashboard/Filas";
import JobDetails from "views/Dashboard/Metadados_page";
import { Text } from '@chakra-ui/react';

import { LineChart, UserRoundCog, Container, ArchiveRestore, Captions, BookAudio, BookHeadphones, DatabaseBackup, MessageSquareMore, NotepadTextDashed } from 'lucide-react';

import {
  HomeIcon,
  HelpIcon,
} from "components/Icons/Icons";

import { PhoneIcon } from '@chakra-ui/icons'

import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ScreenSearchDesktopOutlinedIcon from '@mui/icons-material/ScreenSearchDesktopOutlined';
import DvrRoundedIcon from '@mui/icons-material/DvrRounded';

var dashRoutes = [
 <Text fontSize='1xl' ml={-5}>Utilização</Text>,
  {
    path: "/Dashboard",
    name: "Dashboard",
    icon: <LineChart />,
    component: Dashboard,
    layout: "/admin",
  },
 {
    path: "/filas",
    name: "Filas",
    icon: <LineChart />,
    component: FilaView,
    layout: "/admin",
  },
  {
    path: "/repos_new",
    name: "Bibliotecas de Áudio",
    icon: <BookHeadphones />,
    component: RepositoriesViewNew,
    layout: "/admin",
  },
   {
    path: "/audios",
    name: "Áudios",
    icon: <GraphicEqOutlinedIcon color="inherit" />,
    component: AudiosView,
    layout: "/admin",
  },
  {
    path: "/audit_cadastro",
    name: "Fichas",
    icon: <BookAudio />,
    component: AuditCadastroView,
    layout: "/admin",
  },
  {
    path: "/audit_jobs",
    name: "Processamento Automático",
    icon: <DatabaseBackup />,
    component: Jobs,
    layout: "/admin",
  },
  {
    path: "/transcripts",
    name: "Transcrições",
    icon: <Captions />,
    component: TranscriptsView,
    layout: "/admin",
  },
  <Text fontSize='1xl' ml={-5}>Relatórios</Text>,
  {
    path: "/extracoes",
    name: "Relatórios",
    icon: <AssessmentOutlinedIcon color="inherit" />,
    component: ExtracoesView,
    layout: "/admin",
  },
  {
    path: "/results",
    name: "Fichas Individuais",
    icon: <DvrRoundedIcon color="inherit" />,
    component: ResultsView,
    layout: "/admin",
  },
  {
    path: "/newresults",
    name: "Resultado de uma ficha",
    icon: <NotepadTextDashed  />,
    component: ResultFichaView,
    layout: "/admin",
  },
  {
    path: "/relatorios",
    name: "Monitoramento",
    icon: <ScreenSearchDesktopOutlinedIcon color="inherit" />,
    component: Relatorios,
    layout: "/admin",
  },
  <Text fontSize='1xl' ml={-5}>Cadastro Operacional</Text>,
  {
    path: "/campanhas/:description/:idcampanhas",
    name: "Campanhas",
    icon: <ArchiveRestore />,
    component: CampanhasView,
    layout: "/admin",
  },
  {
    path: "/operacoes",
    name: "Operações",
    icon: <Container />,
    component: OperationsView,
    layout: "/admin",
  },
  {
    path: "/perguntas/:Audit_id",
    name: "Perguntas",
    icon: <HelpIcon color="inherit" />,
    component: PerguntasView,
    layout: "/admin",
  },
  {
    path: "/metadados/:idtranscript_scheduller",
    name: "Metadados",
    icon: <HelpIcon color="inherit" />,
    component: JobDetails,
    layout: "/admin",
  },
  {
    path: "/compania",
    name: "Empresas",
    icon: <HomeIcon color="inherit" />,
    component: CompaniaView,
    layout: "/admin",
  },
  {
    path: "/AudioPage",
    name: "Áudio",
    icon: <PhoneIcon color="inherit" />,
    component: SingleAudio,
    layout: "/admin",
  },
  <Text fontSize='1xl' ml={-5}>Configurações</Text>,
  {
    path: "/usuarios",
    name: "Usuários",
    icon: <UserRoundCog />,
    component: UsuariosView,
    layout: "/admin",
  },
  {
    path: "/logs",
    name: "Logs",
    icon: <MessageSquareMore />,
    component: LogsView,
    layout: "/admin",
  }
];
export default dashRoutes;